const promoDescrText = {
    eng: {
        promoDescr: "Integrated solutions for web development and design, SMM, promotion and video production. ",
        promoMoto: "We know how to attract and retain your customers!",


    },
    ru: {
        promoDescr: "Комплексные решения в сфере разработки сайтов, дизайна, продвижение в соц.сетях (SMM) , продвижения и видеопроизводства",
        promoMoto: "Знаем, как привлечь и удержать ваших клиентов!"
    },
    az: {
        promoDescr: "Sayt hazırlanması, dizayn, SMM, tanıtım və video istehsalı sahəsində kompleks həllər təqdim edirik.",
        promoMoto: "Müştərilərinizi necə cəlb edib saxlamağı bilirik!",
    }
}

export default promoDescrText